/**
 * Teammate user search
 * Handles autocomplete search for adding teammates
 */

let searchTimeout = null;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function clearUserSelection() {
  document.getElementById('user_id').value = '';
  document.getElementById('invite_email').value = '';
  document.getElementById('userSearchInput').value = '';
  document.getElementById('userSearchContainer').removeAttribute('data-js-hidden');
  document.getElementById('selectedUserDisplay').setAttribute('data-js-hidden', '');
  document.getElementById('inviteUserDisplay').setAttribute('data-js-hidden', '');
}

function selectUser(userId, displayName) {
  document.getElementById('user_id').value = userId;
  document.getElementById('invite_email').value = '';
  document.getElementById('selectedUserText').textContent = displayName;
  document.getElementById('userSearchContainer').setAttribute('data-js-hidden', '');
  document.getElementById('selectedUserDisplay').removeAttribute('data-js-hidden');
  document.getElementById('inviteUserDisplay').setAttribute('data-js-hidden', '');
  document.getElementById('userSearchResults').setAttribute('data-js-hidden', '');
}

function selectInviteEmail(email) {
  document.getElementById('user_id').value = '';
  document.getElementById('invite_email').value = email;
  document.getElementById('inviteUserEmail').textContent = email;
  document.getElementById('userSearchContainer').setAttribute('data-js-hidden', '');
  document.getElementById('inviteUserDisplay').removeAttribute('data-js-hidden');
  document.getElementById('selectedUserDisplay').setAttribute('data-js-hidden', '');
  document.getElementById('userSearchResults').setAttribute('data-js-hidden', '');
}

function searchUsers(query, searchUrl) {
  if (query.length < 2) {
    document.getElementById('userSearchResults').setAttribute('data-js-hidden', '');
    return;
  }

  fetch(`${searchUrl}?q=${encodeURIComponent(query)}`)
    .then(response => response.json())
    .then(data => {
      const resultsDiv = document.getElementById('userSearchResults');
      resultsDiv.innerHTML = '';

      if (data.users.length > 0) {
        data.users.forEach(user => {
          const item = document.createElement('button');
          item.type = 'button';
          item.className = 'list-group-item list-group-item-action';

          // Build display name
          let displayName = user.username;
          let fullName = '';
          if (user.first_name || user.last_name) {
            fullName = [user.first_name, user.last_name].filter(n => n).join(' ');
          }

          // Build avatar HTML
          let avatarHTML = '';
          if (user.avatar_url) {
            avatarHTML = `<img src="${user.avatar_url}" class="rounded-circle me-2" style="width: 32px; height: 32px; object-fit: cover;">`;
          } else {
            const initial = user.username.charAt(0).toUpperCase();
            avatarHTML = `<div class="rounded-circle bg-secondary text-white d-inline-flex align-items-center justify-content-center me-2" style="width: 32px; height: 32px; font-size: 14px;">${initial}</div>`;
          }

          // Build content HTML
          let contentHTML = `<div class="d-flex align-items-center">
            ${avatarHTML}
            <div>
              <div><strong>${displayName}</strong></div>`;

          if (fullName) {
            contentHTML += `<div class="small text-muted">${fullName}</div>`;
          }

          contentHTML += `</div></div>`;

          item.innerHTML = contentHTML;
          item.onclick = () => selectUser(user.id, displayName);
          resultsDiv.appendChild(item);
        });
        resultsDiv.removeAttribute('data-js-hidden');
      } else {
        // No users found - check if it's a valid email for invite
        if (emailRegex.test(query)) {
          const item = document.createElement('button');
          item.type = 'button';
          item.className = 'list-group-item list-group-item-action list-group-item-primary';
          item.innerHTML = `<div><strong>Send invite to:</strong> ${query}</div>`;
          item.onclick = () => selectInviteEmail(query);
          resultsDiv.appendChild(item);
          resultsDiv.removeAttribute('data-js-hidden');
        } else {
          resultsDiv.innerHTML = '<div class="list-group-item"><small class="text-muted">No users found. Enter a valid email to send an invite.</small></div>';
          resultsDiv.removeAttribute('data-js-hidden');
        }
      }
    })
    .catch(error => {
      console.error('Error searching users:', error);
    });
}

function initCollaboratorSearch(searchUrl) {
  const searchInput = document.getElementById('userSearchInput');
  if (!searchInput) return;

  searchInput.addEventListener('input', function(e) {
    const query = e.target.value.trim();

    clearTimeout(searchTimeout);

    if (query.length < 2) {
      document.getElementById('userSearchResults').setAttribute('data-js-hidden', '');
      return;
    }

    searchTimeout = setTimeout(() => {
      searchUsers(query, searchUrl);
    }, 300);
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('#userSearchInput') && !e.target.closest('#userSearchResults')) {
      document.getElementById('userSearchResults').setAttribute('data-js-hidden', '');
    }
  });
}

// Auto-initialize from data-search-url attribute
document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('[data-search-url]');
  if (form) {
    initCollaboratorSearch(form.dataset.searchUrl);
  }
});
